import { useEffect, useRef, useState } from 'react'

const FIRMA_W = 500
const FIRMA_H = 200

export default function SignatureCanvasPad({
  onConfirm,
  confirmLabel = 'Conferma e Firma Verbale',
}: {
  onConfirm: (blob: Blob) => void
  confirmLabel?: string
}) {
  const ref = useRef<HTMLCanvasElement>(null)
  const drawing = useRef(false)
  const hasStrokes = useRef(false)
  const [isEmpty, setIsEmpty] = useState(true)

  useEffect(() => {
    const c = ref.current
    if (!c) return
    c.width = FIRMA_W
    c.height = FIRMA_H
    const ctx = c.getContext('2d')!
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, FIRMA_W, FIRMA_H)
    ctx.strokeStyle = '#1e293b'
    ctx.lineWidth = 2.5
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
  }, [])

  const pos = (e: React.MouseEvent | React.TouchEvent) => {
    const c = ref.current!
    const r = c.getBoundingClientRect()
    const sx = FIRMA_W / r.width
    const sy = FIRMA_H / r.height
    if ('touches' in e) {
      return { x: (e.touches[0].clientX - r.left) * sx, y: (e.touches[0].clientY - r.top) * sy }
    }
    return { x: (e.clientX - r.left) * sx, y: (e.clientY - r.top) * sy }
  }

  const start = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault()
    drawing.current = true
    const ctx = ref.current!.getContext('2d')!
    const { x, y } = pos(e)
    ctx.beginPath()
    ctx.moveTo(x, y)
  }

  const draw = (e: React.MouseEvent | React.TouchEvent) => {
    if (!drawing.current) return
    e.preventDefault()
    hasStrokes.current = true
    setIsEmpty(false)
    const ctx = ref.current!.getContext('2d')!
    const { x, y } = pos(e)
    ctx.lineTo(x, y)
    ctx.stroke()
  }

  const stop = () => { drawing.current = false }

  const clear = () => {
    const c = ref.current!
    const ctx = c.getContext('2d')!
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, FIRMA_W, FIRMA_H)
    hasStrokes.current = false
    setIsEmpty(true)
  }

  const confirm = () => {
    if (!hasStrokes.current) {
      alert('Disegna la tua firma prima di confermare')
      return
    }
    ref.current!.toBlob(blob => {
      if (blob) onConfirm(blob)
    }, 'image/png')
  }

  return (
    <div>
      <canvas
        ref={ref}
        style={{
          border: '2px solid #d1d5db',
          borderRadius: 10,
          width: '100%',
          height: 160,
          cursor: 'crosshair',
          touchAction: 'none',
          display: 'block',
          background: '#fff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        }}
        onMouseDown={start} onMouseMove={draw} onMouseUp={stop} onMouseLeave={stop}
        onTouchStart={start} onTouchMove={draw} onTouchEnd={stop}
      />
      <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
        <button
          onClick={clear}
          style={{
            flex: 1, padding: '12px 0', borderRadius: 8, border: '1.5px solid #d1d5db',
            background: '#f9fafb', fontSize: 14, cursor: 'pointer', fontWeight: 600,
          }}
        >
          Pulisci
        </button>
        <button
          onClick={confirm}
          disabled={isEmpty}
          style={{
            flex: 2, padding: '12px 0', borderRadius: 8, border: 'none',
            background: isEmpty ? '#9ca3af' : '#1E40AF', color: '#fff',
            fontSize: 14, fontWeight: 700, cursor: isEmpty ? 'not-allowed' : 'pointer',
            transition: 'background 0.2s',
          }}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  )
}
